// <fiee-lightbox> opens the plan and specialization-line images of /mallas in
// a native modal <dialog>. The triggers are ordinary links to the image, so
// without JavaScript they still open the full picture in a new tab; this island
// only intercepts them and shows it on the page instead.
export class FieeLightbox extends HTMLElement {
  #dialog: HTMLDialogElement | null = null;
  #image: HTMLImageElement | null = null;
  #onClick = (e: Event) => this.#open(e);

  connectedCallback() {
    this.#dialog = this.querySelector<HTMLDialogElement>("dialog");
    this.#image = this.querySelector<HTMLImageElement>("[data-lightbox-image]");
    if (!this.#dialog || !this.#image) return;

    document.addEventListener("click", this.#onClick);
    this.#dialog.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      // A click on the <dialog> itself is a click on the backdrop.
      if (target === this.#dialog || target.closest("[data-lightbox-close]")) {
        this.#dialog?.close();
      }
    });
    this.#dialog.addEventListener("close", () => {
      this.#image?.removeAttribute("src");
      if (this.#image) this.#image.alt = "";
    });
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.#onClick);
  }

  #open(e: Event) {
    const trigger = (e.target as Element).closest<HTMLElement>("[data-lightbox-src]");
    const src = trigger?.dataset["lightboxSrc"];
    if (!trigger || !src || !this.#dialog || !this.#image) return;

    e.preventDefault();
    this.#image.src = src;
    this.#image.alt = trigger.dataset["lightboxAlt"] ?? "";
    if (!this.#dialog.open) this.#dialog.showModal();
  }
}
